<template>
  <section v-if="isEditable || photos.length" class="section--photos">
    <ul class="photos">
      <div class="photo" v-for="(photo, index) in photos" :key="photo.id">
        <img :src="domain + photo.url" class="photo__item img-fluid" alt="">
        <span v-if="isEditable"
          @click="removePhotoID(photos, index, photo.id)"
          class="photo__remove">×
        </span>
      </div>
      <div class="photo" v-for="(newPhoto, index) in newPhotos" :key="'New' + index">
        <img :src="newPhoto.base64" class="photo__item img-fluid" alt="">
        <span v-if="isEditable"
          @click="removePhoto(newPhotos, index)"
          class="photo__remove">×
        </span>
      </div>
        <button
          v-if="addNewPossibility"
          type="button"
          @click="addPhotos"
          class="photo photo--add">
            <span class="pb-2 photo__info">{{ $t("results.photo") }}</span>
            <i class="fas fa-plus fa-2x"></i>
        </button>
        <upload-base64 :multiple="false" :done="getFiles" ref="file_input"></upload-base64>
    </ul>
  </section>
</template>

<script>
import UploadBase64 from '@/components/UploadBase64';

export default {
  components: {
    UploadBase64,
  },
  data() {
    return {
      domain: process.env.SERVER_URL,
    };
  },
  props: ['photos', 'newPhotos', 'isEditable', 'deletedPhotos'],
  computed: {
    addNewPossibility() {
      return this.isEditable && this.photos.length < 10;
    },
  },
  methods: {
    getFiles(files) {
      this.newPhotos.push(files);
    },
    addPhotos() {
      this.$refs.file_input.$refs.input.click();
      this.$emit('newPhotos', this.newPhotos);
    },
    removePhoto(from, photoIndex) {
      from.splice(photoIndex, 1);
    },
    removePhotoID(from, photoIndex, photoID) {
      this.removePhoto(from, photoIndex);
      this.deletedPhotos.push(photoID);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";
.section--photos {
  background-color: $color--white-1;
  padding: 50px 75px 0;
  margin-top: 10px;
}
.photos {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
}
.photo {
  width: 165px;
  height: 140px;
  margin: 0 15px 50px;
  background-color: gray;
  position: relative;
  &__item {
    width: 100%;
    height: 100%;
  }
  &__remove {
    position: absolute;
    background-color: $color--white-3;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -5px;
    right: -5px;
    font-size: 16px;
    cursor: pointer;
  }
  &__info {
    color: $color--white;
    font-size: 22px;
    font-weight: bold;
  }
  &--add {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    &__input {
      position: absolute;
      left: 0;
      top: 0;
      cursor: pointer;
      opacity: 0;
      padding: 0;
      border: 0;
      background: transparent;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Game/Results/PhotosList.vue